export const enum QuestionType {
  Undefined = "Undefined",
  Location = "Location",
  Multiple = "Multiple",
  Single = "Single",
  Color = "Color",
  Confirmation = "Confirmation",
}

declare enum MandatoryState {
  Yes = "Yes",
  No = "No",
  Conditional = "Conditional",
}

export declare interface OptionDefinitionDto {
  key: string;
  display?: string;
  label: string;
  value: string;
  isTextInput?: boolean;
  isMandatory?: boolean;
}

type MandatoryIf = {
  [key: string]: string[];
};

export declare interface QuestionDefinitionDto {
  key: string;
  title: string;
  text: string;
  textFrench: string;
  questionType: QuestionType;
  mandatoryIf: MandatoryIf;
  maxNumberOfAnswers?: number;
  isMandatory?: MandatoryState;
  options?: OptionDefinitionDto[];
}

type Anwser = {
  [key: string]: string;
};

export declare interface Question {
  key: string;
  label: string;
  answers: Anwser[];
}

export declare interface QuestionnaireModel {
  questions: Question[];
  questionSetVersion?: string;
}

export interface QuestionaireResponse {
  createdAtUtc: string;
  createdByUserId: number;
  id: string;
  questionSetVersion: string;
  questions: Question[];
  transferOwnershipToken: string;
  userId: number;
}

export declare interface RegistrationInfoDto {
  ownerUserId: number;
  answerSetToken: string;
}

declare enum TestkitStatus {
  Unknown = 0,
  Ordered = 10,
  KitOnTheWay = 20,
  KitDelivered = 30,
  Registered = 40,
  SampleOnTheWay = 50,
  SampleReceived = 60,
}

export declare interface TestKitDto {
  testKitId: number;
  activationCode?: string;
  activationDateUtc?: string;
  status: TestkitStatus;
  remarks: string;
  purchaseId?: number;
}
